export function isTrialGateway(model?: string | null) {
  return model === 'Lumeo Cloud Trial';
}

export function isOnDemandGateway(model?: string | null) {
  return model === 'Lumeo Cloud OnDemand';
}
